import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Whoops.  This page doesn't exist</h1>
        </div>
    )
}


export default NotFound;


// WEBPACK FOOTER //
// ./src/components/elements/NotFound/NotFound.js